import { ScreensaverState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: ScreensaverState = {
  screensaverImages: null,
  showing: false,
  lastInteraction: Date.now(),
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'UPDATE_SCREENSAVER_IMAGES':
      return {
        ...state,
        screensaverImages: action.payload.collections
          .find((collection: any) => collection.slug === 'top-10-shows')
          .content.map((content: any) => content.images['show-mezzanine16x9'])
          .filter((x: any) => !!x)
          .slice(0, 10),
      }

    case 'SET_APP_INTERACTION':
      return { ...state, lastInteraction: Date.now() }

    case 'SCREENSAVER_VISIBILITY':
      return { ...state, showing: action.payload }

    default:
      return state
  }
}
